<template>
  <div class="loginBox">
    <div class="loginContent">
      <div class="tabBox">
        <div
          class="tabItem"
          @click="tabChange(item)"
          :class="[item.id == isActive ? 'active' : '']"
          v-for="(item, i) in tabList"
          :key="i"
        >
          {{ item.title }}
        </div>
      </div>
      <div class="modelCheck">
        <div class="loginFor">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="125px"
            class="demo-ruleForm"
          >
            <el-form-item label="账 号：" prop="username" v-if="isActive == 1">
              <el-input
                type="text"
                size="large"
                v-model.trim="ruleForm.username"
                placeholder="请输入手机号"
                maxlength="11"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="统一识别代码："
              prop="Identification"
              v-if="[2, 3].includes(Number(isActive))"
            >
              <el-input
                type="text"
                size="large"
                v-model.trim="ruleForm.Identification"
                placeholder="请输入统一识别代码后6位"
                maxlength="6"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="密 码：" prop="password">
              <el-input
                type="password"
                show-password
                size="large"
                v-model.trim="ruleForm.password"
                placeholder="请输入密码"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="验证码："
              prop="code"
              v-if="website.captchaMode"
            >
              <el-row>
                <el-col :span="16" style="height: 40px">
                  <el-input
                    size="large"
                    v-model.trim="ruleForm.code"
                    placeholder="请输入验证码"
                  ></el-input>
                </el-col>
                <el-col :span="8" style="height: 40px">
                  <img
                    class="refreshCode"
                    :src="ruleForm.image"
                    @click="refreshCode"
                    alt=""
                  />
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item
              label-width="0px"
              prop="agree"
              style="margin-top: 50px"
            >
              <el-checkbox-group v-model="ruleForm.agree" style="height: 30px">
                <el-checkbox
                  label="同意《“一带一路”职业教育》协议"
                  name="agree"
                ></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-form>
          <el-button
            style="width: 100%; background: #2077b5; height: 40px"
            type="primary"
            @click="submitForm('ruleForm')"
            >登录</el-button
          >
          <div @click="toRegister" class="registerBtn">还没有账号？去注册</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCaptcha } from "@/api/register";
export default {
  name: "login",
  data() {
    let validateIdentification = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入统一识别代码"));
      } else {
        callback();
      }
    };
    let validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入账号"));
      } else {
        callback();
      }
    };
    return {
      isActive: 2,
      tabList: [
        // {
        //   id: 1,
        //   title: "个人登录",
        // },
        {
          id: 2,
          title: "机构登录",
        },
        {
          id: 3,
          title: "院校登录",
        },
      ],
      ruleForm: {
        tenantId: "000000",
        Identification: "",
        password: "",
        username: "",
        code: "", //验证码的值
        image: "",
        key: "", ////验证码的索引
        type: "account",
        agree: "",
        dataType: "",
      },
      rules: {
        username: [
          {
            required: true,
            validator: validateUsername,
            trigger: "blur",
          },
        ],
        Identification: [
          {
            required: true,
            validator: validateIdentification,
            trigger: "blur",
          },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        agree: [{ required: true, message: "请同意协议", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
    };
  },
  created() {
    this.refreshCode();
  },
  mounted() {
    this.isActive = this.$route.query.type ? this.$route.query.type : 2;
  },
  methods: {
    refreshCode() {
      if (this.website.captchaMode) {
        getCaptcha().then((data) => {
          this.ruleForm.key = data.key;
          this.ruleForm.image = data.image;
        });
      }
    },
    toRegister() {
      this.$router.push({
        path: "/register/index",
        query: { type: this.isActive },
      });
    },
    tabChange(row) {
      this.isActive = row.id;
      this.$nextTick(() => {
        this.$refs["ruleForm"].resetFields();
        this.$refs["ruleForm"].clearValidate();
      });
      this.refreshCode();
    },
    submitForm(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let loginForm = { ...that.ruleForm };
          if ([2, 3].includes(Number(that.isActive))) {
            loginForm.username = loginForm.Identification;
            if (that.isActive == 2) loginForm.dataType = 2;
            if (that.isActive == 3) loginForm.dataType = 1;
            delete loginForm.Identification;
          }
          const loading = that.$loading({
            lock: true,
            text: "登录中,请稍后。。。",
            spinner: "el-icon-loading",
          });

          that.$store
            .dispatch("LoginByUsername", loginForm)
            .then(() => {
              that.$router.push({ path: "/" });
              loading.close();
            })
            .catch(() => {
              loading.close();
              that.refreshCode();
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style lang="less" scoped>
.loginBox {
  width: 100%;
  min-height: calc(100vh - 300px - 140px);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 0;
  box-sizing: border-box;

  .loginContent {
    width: 600px;
    border-radius: 11px;
    background: #fff;
    overflow: hidden;
    @media (max-width: 768px) {
      width: 100%;
    }
    .tabBox {
      display: flex;

      .tabItem {
        width: 50%;
        height: 64px;
        line-height: 64px;
        text-align: center;
        border-bottom: 1px solid #d9d9d9;
        cursor: pointer;
      }

      .active {
        // background: #3c70a2;
        color: #2077b5;
        font-weight: 700;
        position: relative;
        border-bottom: 2px solid #2077b5;

        &:before {
          content: "";
          border: 10px solid transparent;
          border-bottom-color: #fff;
          bottom: 0;
          left: 50%; //根据三角形的位置，可以随意更改。
          transform: translateX(-50%);
          position: absolute;
        }
      }
    }

    .loginFor {
      padding: 30px 30px 20px 30px;
      box-sizing: border-box;
      @media (max-width: 768px) {
        padding: 20px;
      }
      .refreshCode {
        @media (max-width: 768px) {
          width: 80px;
        }
      }
      .registerBtn {
        color: #ef9143;
        font-size: 14px;
        text-align: right;
        margin: 15px 0;
        cursor: pointer;
      }
    }
  }
}
</style>